import { ReactNode } from 'react';
import { Element } from 'react-scroll';
import {
  StyledJobOfferSection,
  StyledJobOfferSectionContainer,
  StyledJobOfferSectionHeader,
  StyledJobOfferSectionIntro,
  StyledJobOfferSectionTitle
} from './JobOfferSection.styled';

export type JobOfferSectionType = {
  name: string;
  sectionBg?: string;
  children?: ReactNode;
  title: string;
  intro?: string;
};

const JobOfferSection = ({
  name,
  sectionBg,
  children,
  title,
  intro
}: JobOfferSectionType) => (
  <Element name={name} id={name}>
    <StyledJobOfferSection sectionBg={sectionBg}>
      <StyledJobOfferSectionContainer>
        <StyledJobOfferSectionHeader>
          <StyledJobOfferSectionTitle editorial>
            {title}
          </StyledJobOfferSectionTitle>
          {intro && (
            <StyledJobOfferSectionIntro>
              <div dangerouslySetInnerHTML={{ __html: intro || '' }}></div>
            </StyledJobOfferSectionIntro>
          )}
        </StyledJobOfferSectionHeader>
        {children}
      </StyledJobOfferSectionContainer>
    </StyledJobOfferSection>
  </Element>
);

export default JobOfferSection;
